import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Field, Form, Formik } from 'formik';
import MaterialInput from '../quickApplications/CreateQuickApplication/components/MaterialInput';
import FieldLabel from '../quickApplications/CreateQuickApplication/components/FieldLabel';
import MaterialSelect from '../quickApplications/CreateQuickApplication/components/MaterialSelect';
import { dictionaryHelper } from '../../../helpers/dictionaryHelper';
import {apvgkService} from "../../../services/apvgkService";
import MaterialCheckbox from "../quickApplications/CreateQuickApplication/components/MaterialCheckbox";


const Filter = ({ currentFilters, onFiltersChange }) => {
    const [open, setOpen] = useState(false);

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }

    const onCancel = () => {
        onFiltersChange({});
        handleClose()
    };
    const checkboxHandler = (setField) => async (e) => {
        setField(e.target.name, e.target.checked)
    }
    return (
        <div>
            <Link

                color="primary"
                to={{}}
                onClick={handleClickOpen}
            >
                Фильтровать
            </Link>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <Toolbar>
                    <Typography variant="title" color="inherit" className="flex">
                        Фильтровать
                    </Typography>
                    <IconButton color="inherit" onClick={handleClose}>
                        <CloseIcon className="blue" />
                    </IconButton>
                </Toolbar>
                <DialogContent>
                    <Formik
                        initialValues={{...currentFilters,
                            min_date: currentFilters.min_date.replace(' ', 'T'),
                            max_date: currentFilters.min_date.replace(' ', 'T')
                        } }
                        onSubmit={values => {
                            onFiltersChange(values);
                            handleClose();
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        render={({ values, setFieldValue }) => (
                            <Form>
                                <Grid container direction="column" spacing={16} wrap="nowrap">
                                    <Grid item>
                                        <FieldLabel label="Дата время с" name="min_date">
                                            <Field
                                                name="min_date"
                                                component={MaterialInput}
                                                type="datetime-local"
                                                // required="required"
                                            />
                                        </FieldLabel>
                                    </Grid>
                                    <Grid item>
                                        <FieldLabel label="Дата время по" name="max_date">
                                            <Field
                                                name="max_date"
                                                component={MaterialInput}
                                                type="datetime-local"
                                                // required="required"
                                            />
                                        </FieldLabel>
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className="btn-add no-margin"
                                            type="submit"
                                        >
                                            Применить
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            className="info-btn"
                                            onClick={onCancel}
                                        >
                                            Очистить
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Filter;
